import { cn } from "@/utils";

type PageHeaderProps = {
  title: string;
  description?: string;
  Icon?: React.ComponentType<{ className?: string }>;
  className?: string;
  actions?: React.ReactNode;
};

export function PageHeader({
  title,
  description,
  Icon,
  className,
  actions,
}: PageHeaderProps) {
  return (
    <div className={cn("", className)}>
      {Icon && (
        <div className="mb-6 inline-flex items-center justify-center rounded-xl border border-border bg-background p-3.5 shadow-sm">
          <Icon className="size-6 text-foreground" />
        </div>
      )}
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold text-foreground lg:text-3xl">
          {title}
        </h1>
        {actions && actions}
      </div>
      {description && (
        <p className="text-md mt-1 text-muted-foreground lg:mt-3">
          {description}
        </p>
      )}
    </div>
  );
}
